import { ResourceModel } from "../../generics/models/generic-resource-model";

export class UserPreferences extends ResourceModel<UserPreferences> {
 
  public id: number;
  public sideBarFilterColor: string;
  public sideBarBackgroundColor: string;
  public sideBarMiniEnabled: boolean;
  public sideBarImageEnabled: boolean;
  public imageName: string;

  constructor(model?: Partial<UserPreferences>) {
    super(model);
  }
}

export class UserPreferencesDTO extends UserPreferences {
  public userID?: number;
}
